export const initialState = () => ({
  listOffersCombo: [],
  paginationOffersCombo: {},
  optionsOffersCombo: [],
  currentPage: 1,
  combosFilter: {
    name: ""
  }
})
